<template>
  <v-tooltip
    v-if="!isDesktop || isExtensionPopup"
    :open-on-hover="true"
    location="top" :open-delay="300"
    content-class="text-neutral0 bg-neutral900"
    :disabled="isMobile"
  >
    <span>{{ t('cta.filter') }}</span>
    <template #activator="{ props: tooltipProps }">
      <BrandButton
        variant="secondary"
        color="neutral25"
        class="text-neutral900"
        v-bind="{ ...tooltipProps, ...toolbarBtnProps, ...$attrs }"
        flat
      >
        <!-- The filters sit in a sidebar this button opens, so while it is closed
             the dot is the only sign that some are set. -->
        <BrandBadge
          :model-value="activeCount > 0" :label="tc('common.filters_active', activeCount)"
          :width="DOT_SIZE" :height="DOT_SIZE" rounded="circle"
          :offset-x="DOT_OFFSET" :offset-y="DOT_OFFSET"
        >
          <PhFadersHorizontal class="text-h5" />
        </BrandBadge>
        <span v-if="!isCompact" class="ml-3" v-text="t('cta.filter')" />
      </BrandButton>
    </template>
  </v-tooltip>
</template>

<script setup>
import { computed, defineOptions, defineProps } from 'vue'
import { useStore } from 'vuex'
import { useDisplay } from 'vuetify'
import { PhFadersHorizontal } from '@phosphor-icons/vue'
import { useToolbarButtonStyle } from '@/composables/useToolbarButtonStyle'
import { useTranslation } from '@/composables/useTranslation'

defineOptions({ inheritAttrs: false })

// The dot on this button is larger than BrandBadge's 9px. The offset moves it off
// the corner of the 24px icon out over the rim of the round 45px button around
// it (useToolbarButtonStyle), at the top right: it goes with the size.
const DOT_SIZE = 14
const DOT_OFFSET = 3.1

const props = defineProps({
  // The filters that are set, named as computeFiltersActive answers them, or false when none is.
  activeFilters: {
    type: [Array, Boolean],
    default: false,
  },
})

const store = useStore()
const { t, tc } = useTranslation()
const display = useDisplay()
const isMobile = computed(() => display.smAndDown.value)
const { isCompact, toolbarBtnProps } = useToolbarButtonStyle()

const isExtensionPopup = computed(() => store.getters['device/isExtensionPopup'])
const isDesktop = computed(() => store.getters['device/isDesktop'])

const activeCount = computed(() => props.activeFilters?.length ?? 0)
</script>
